import { Component, Input } from '@angular/core'
import { BsModalRef } from 'ngx-bootstrap/modal'
import { Booking } from '../../booking/booking'

export interface ParticipantBookingOverviewRow {
  booking: Booking
  participationStatus?: number
  isAttending: boolean
}

@Component({
  selector: 'participant-bookings-modal',
  templateUrl: './participant-bookings-modal.component.html',
  styleUrls: ['./participant-bookings-modal.component.scss']
})
export class ParticipantBookingsModalComponent {
  @Input() participantName: string = ''
  @Input() bookingRows: ParticipantBookingOverviewRow[] = []

  constructor(public bsModalRef: BsModalRef) {}
}
